import { getAvatarIdentityTone, getAvatarInitials } from '@/lib/avatarIdentity';

function escapeSvgText(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&apos;');
}

/** Stable, self-contained avatars for AX1 Capital demo / showcase personas. */
export function demoAvatarFor(seed: string, size = 150, displayName?: string): string {
  const normalized = (seed || 'ax1-demo').trim().toLowerCase();
  const pixels = Math.max(32, Math.min(512, Math.round(Number.isFinite(size) ? size : 150)));
  const labelSource = displayName || normalized.split('@')[0] || 'AX1';
  const label = escapeSvgText(getAvatarInitials(labelSource));
  const background = getAvatarIdentityTone(normalized).demoHex;
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${pixels}" height="${pixels}" viewBox="0 0 100 100" role="img" aria-label="Demo avatar"><rect width="100" height="100" rx="50" fill="${background}"/><text x="50" y="54" text-anchor="middle" dominant-baseline="middle" fill="#fff" font-family="Inter,Arial,sans-serif" font-size="36" font-weight="700" letter-spacing="-1">${label}</text></svg>`;

  return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
}

/** True when a catalog avatar is missing or points at a removed local asset. */
export function isMissingDemoAvatar(avatar?: string | null): boolean {
  if (!avatar || !avatar.trim()) return true;
  // Legacy showcase path — file is no longer shipped in /public
  if (avatar === '/tania-admin.png' || avatar.endsWith('/tania-admin.png')) return true;
  return false;
}

export function ensureDemoAvatar<T extends { id?: string; email?: string; name?: string; avatar?: string }>(
  person: T,
): T & { avatar: string } {
  if (!isMissingDemoAvatar(person.avatar)) return person as T & { avatar: string };
  const seed = person.id || person.email || person.name || 'ax1-demo';
  return { ...person, avatar: demoAvatarFor(seed, 150, person.name) };
}
